import React from "react";

const PoliticaPrivacidad = () => (
  <div className="document-container">
    <div className="politica-privacidad">
      <h1>Política de Privacidad</h1>
      <p>
        En CONESA SOCIAL MEDIA, estamos comprometidos con la protección de la privacidad
        y los datos personales de nuestros usuarios. Esta Política de Privacidad
        describe qué datos personales recopilamos, cómo los procesamos, y qué
        derechos tiene usted sobre sus datos.
      </p>
      <h2>Recopilación de Datos Personales</h2>
      <p>
        Recopilamos información personal que usted nos proporciona directamente,
        como su nombre, correo electrónico y número de teléfono cuando completa
        formularios en nuestro sitio web o se comunica con nosotros. También
        podemos recopilar automáticamente cierta información, como la dirección
        IP, el navegador utilizado y la página de referencia.
      </p>
      <h2>Uso de Datos Personales</h2>
      <p>
        Utilizamos sus datos personales para proporcionarle información,
        gestionar sus solicitudes y mejorar nuestros servicios. También podemos
        usar estos datos para enviarle comunicaciones comerciales, siempre que
        tengamos su consentimiento para ello.
      </p>
      <h2>Protección de los Datos</h2>
      <p>
        Implementamos las medidas técnicas y organizativas necesarias para
        proteger sus datos personales contra el acceso no autorizado, la
        pérdida, destrucción o alteración.
      </p>
      <h2>Derechos del Usuario</h2>
      <p>
        Tiene derecho a acceder a sus datos personales, solicitar su
        rectificación, cancelación o limitación de uso, y a oponerse a su
        tratamiento. Puede ejercer estos derechos poniéndose en contacto con
        nosotros a través de info@conesa-social-media.es .
      </p>
      <h2>Modificaciones a esta Política</h2>
      <p>
        Esta Política de Privacidad puede actualizarse periódicamente, y
        notificaremos cualquier cambio en esta página. Le recomendamos revisar
        esta política con frecuencia.
      </p>
    </div>
  </div>
);

export default PoliticaPrivacidad;
